import React from 'react';
import { ShowAt } from 'consts/breakpoints';
import { DesktopSuggestionsWrapper, MobileSubtitle, MobileSuggestionsWrapper } from './styled';
import { useLocale } from 'locale';
import { Route, useRoute } from 'config/routes';

interface SuggestionsWrapperProps {
  children: React.ReactNode;
  searchStr: string;
  insideFiltersSearchMode?: boolean;
}

export const SuggestionsWrapper: React.FC<SuggestionsWrapperProps> = ({ children, searchStr, insideFiltersSearchMode }) => {
  const { t } = useLocale();
  const { route } = useRoute();
  const isInvestorSearch = route.name === Route.InvestorsSearchPage;
  return (
    <>
      <ShowAt from={3}>
        <DesktopSuggestionsWrapper data-auto="autocomplete-suggestions">
          {children}
        </DesktopSuggestionsWrapper>
      </ShowAt>
      <ShowAt to={2}>
        <MobileSuggestionsWrapper data-auto="autocomplete-suggestions" insideFiltersSearchMode={insideFiltersSearchMode}>
          {searchStr || isInvestorSearch ? null : (
            <MobileSubtitle weight={insideFiltersSearchMode ? 'bold' : 'medium'} insideFiltersSearchMode={insideFiltersSearchMode}>
              {t('autocompleteInput.multi.suggestionsTitle')}
            </MobileSubtitle>
          )}
          {children}
        </MobileSuggestionsWrapper>
      </ShowAt>
    </>
  );
};
